var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('object',{attrs:{"data":("" + (_vm.$vuetify.theme.dark?
  require(("@/assets/svg/" + _vm.name + "-dark.svg")): require(("@/assets/svg/" + _vm.name + ".svg")))),"type":"image/svg+xml","width":_vm.width}})}
var staticRenderFns = []

export { render, staticRenderFns }